import { ChangeDetectionStrategy, Component, EventEmitter, OnDestroy, Output } from '@angular/core';
import { BookingStore, DocumentsStore } from '@store';
import { SubscriptionPlan } from '@vi-iot/client';

@Component({
  selector: 'app-commercial-booking-summary',
  templateUrl: './commercial-booking-summary.component.html',
  styleUrls: ['./commercial-booking-summary.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CommercialBookingSummaryComponent implements OnDestroy {
  @Output() continue = new EventEmitter<void>();

  BookingPlans = SubscriptionPlan;
  tosAccepted = false;

  constructor(public bookingStore: BookingStore, public documentsStore: DocumentsStore) {}

  onContinue(): void {
    this.continue.emit();
  }

  onTosCheckboxChange(isTosAccepted: boolean): void {
    this.tosAccepted = isTosAccepted;
  }

  ngOnDestroy(): void {
    this.bookingStore.resetSubscriptionsDetails();
  }
}
